<div class="sign-in-form">
  <h1 class="title">{{ labels.HEADER_TITLE }}</h1>
  <form [formGroup]="signInForm">
    <!-- ---------------------- Error Message Box For Invalid Cred ---------------------- -->
    <div class="error-section">
      <lib-g99-message-box
        *ngIf="isUnauthorized"
        [message]="errorMessage"
        [messageColor]="'#d92d21'"
        [icon]="exclamationSvg"
        [iconColor]="'#d92d21'"
      />
    </div>
    <!-- ---------------------- Email Field ---------------------- -->
    <div class="form-group">
      <lib-input
        formControlName="email"
        [label]="labels.EMAIL"
        [isInvalid]="isInvalid('email')"
        [placeholder]="placeholders.EMAIL"
        [formControls]="f['email'] || null"
        [errorMessage]="errorMessages.email"
      />
    </div>
    <!-- ---------------------- Password Field ---------------------- -->
    <div class="form-group">
      <lib-input
        formControlName="password"
        [label]="labels.PASSWORD"
        [isInvalid]="isInvalid('password')"
        [placeholder]="placeholders.PASSWORD"
        [formControls]="f['password'] || null"
        [inputType]="'password'"
        [errorMessage]="errorMessages.password"
      />
      <div class="forgot-password">
        <a class="forgot-password-link" [routerLink]="'/forgot-password'"
          >Recover Password</a
        >
      </div>
    </div>
    <div class="form-group">
      <div class="continue-button">
        <g99-button
          width="100%"
          variant="medium"
          color="green"
          [disabled]="signInForm.invalid"
          [loadingText]="labels.LOADING"
          [isLoading]="isLoading"
          (buttonClick)="onLogin()"
        >
          Continue
        </g99-button>
      </div>
    </div>
  </form>
</div>
